import * as React from "react";
import {Datagrid, DateField, DeleteWithConfirmButton, FunctionField, List, TextField, TextInput} from 'react-admin';

const userFilters = [
    <TextInput source="name" label={"Név"} name={"name"} fullWidth required/>,
    <TextInput source="email" label={"E-mail"} name={"email"} fullWidth required/>
];

export const AdminUserList = () => (
    <List title={'Admin felhasználók'}
          sort={{field: 'Default', order: 'DESC'}}
          filters={userFilters}
          exporter={false}
    >
        <Datagrid bulkActionButtons={false} rowClick={"edit"}>
            <TextField source="id" label={"ID"} sortable={false}/>
            <TextField source="name" label={"Név"}/>
            <TextField source="email" label={"E-mail"}/>
            <DateField source="createdAt" locales={['hu-HU']} label={"Létrehozva"} sortable={false}/>
            <FunctionField
                label=""
                render={(record: any) => {
                    const isProtected = record.id === 'cfcd2084-95d5-65ef-66e7-dff9f98764da' || record.id === '5d7b9adc-be1c-629e-c722-529dd12e5129'
                    return isProtected ? null : <DeleteWithConfirmButton
                        confirmTitle={"Admin felhasználó eltávolítása"}
                        confirmContent={"A felhasználó véglegesen kikerül az admin felhasználók közül"}
                    />
                }}
            />
        </Datagrid>
    </List>
);
